export class NotificationSearchModel {
    page?: number = 1;
    pageSize?: number = 10;
    searchText?: string;
}